module.exports = __webpack_public_path__ + "img/new-tsgn_tab6.d8b0928a.png";